import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch, RootState } from '../../../../store/store';
import { extractChannelNumberFromId } from '../../../../utils/channel-utils';
import InteractiveButton from '../../../../components/InteractiveButton/InteractiveButton';
import { generatePath, useNavigate } from 'react-router-dom';
import ROUTE from '../../../../constants/route-constants';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../constants/common';

type Props = { activeChannel: number; controllerId: string };
type StateProps = ReturnType<typeof mapState>;
type DispatchProps = ReturnType<typeof mapDispatch>;

type ComponentProps = StateProps & DispatchProps & Props;

const activeStyle = 'bg-primary text-white';
const inactiveStyle = 'bg-white text-black';

const ChannelsTabsView = ({ getChannels, activeChannel, channels, controllerId }: ComponentProps) => {
  const navigate = useNavigate();

  const fetchData = async (id: string) => {
    await getChannels(id);
  };

  useEffect(() => {
    fetchData(controllerId);
    const intervalId = setInterval(() => fetchData(controllerId), EXTENDED_INTERVAL_UPDATE_DATA);

    return () => clearInterval(intervalId);
  }, [controllerId]);

  const onClickChannel = (channelId: string) => {
    const path = generatePath(ROUTE.EDIT_CONTROLLER_CHANNEL, {
      id: controllerId,
      channel_number: extractChannelNumberFromId(channelId),
    });
    navigate(path);
  };

  return (
    <div className="p-channels-tabs max-md:grid max-md:grid-cols-4 md:flex flex-row flex-wrap gap-3 pb-3 pt-5">
      {channels.map((item) => {
        return (
          <InteractiveButton
            key={item.id}
            text={item.channel}
            onClick={() => onClickChannel(item.id)}
            customType={`bg-primary font-medium border border-burnt-orang hover:bg-[#ff9146] active:bg-[ff6700] ${
              extractChannelNumberFromId(item.id) === activeChannel ? activeStyle : inactiveStyle
            }`}
          />
        );
      })}
    </div>
  );
};

const mapState = (state: RootState) => ({
  channels: state.channels.channels,
});

const mapDispatch = (dispatch: Dispatch) => ({
  getChannels: dispatch.channels.getChannels,
});

export const ChannelsTabs = connect<StateProps, DispatchProps, Props>(mapState, mapDispatch)(ChannelsTabsView);
